import { render, staticRenderFns } from "./ProyectItem.vue?vue&type=template&id=51a9cf05&scoped=true&"
import script from "./ProyectItem.vue?vue&type=script&lang=js&"
export * from "./ProyectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a9cf05",
  null
  
)

export default component.exports